import { Pipe, PipeTransform } from '@angular/core';
import { Manuscript } from '../models/manuscript';

/* Possible sizes of the manuscript title */
export type MsTitleSize = 'default' | 'short' | 'full' | 'norm';

@Pipe({
  name: 'getMsTitle'
})
export class GetMsTitlePipe implements PipeTransform {

    /* Make the manuscript title from data */
    transform(manuscript: Manuscript, titleSize: MsTitleSize = 'default'): string {
        const title: Array<string> = [];
        let titleString = '';

        if (manuscript) {
            if (titleSize === 'norm' && manuscript.__countries_sort) {
                title.push(this.normalizeString(manuscript.__countries_sort));
            } else if (manuscript.__countries) {
                title.push(manuscript.__countries);
            }
            if (titleSize === 'norm' && manuscript.__cities_sort) {
                title.push(this.normalizeString(manuscript.__cities_sort));
            } else if (manuscript.__cities) {
                title.push(manuscript.__cities);
            }
            if (titleSize === 'norm' && manuscript.__libraries_sort) {
                title.push(this.normalizeString(manuscript.__libraries_sort));
            } else if (manuscript.__libraries) {
                title.push(manuscript.__libraries);
            }
            if (manuscript.private_collection) {
                title.push(manuscript.private_collection);
            }
            if (titleSize === 'norm' && manuscript.shelf_mark_norm) {
                title.push(manuscript.shelf_mark_norm);
            } else if (manuscript.shelf_mark) {
                title.push(manuscript.shelf_mark);
            }
//            if (manuscript.__works) {
//                switch (titleSize) {
//                    case 'default':
//                        const workSep = manuscript.__works.indexOf(';');
//                        if (workSep !== -1) {
//                            title.push(manuscript.__works.substr(0, workSep));
//                        } else {
//                            title.push(manuscript.__works);
//                        }
//                        break;
//                    case 'full':
//                        title.push(manuscript.__works);
//                        break;
//                    case 'short':
//                        break;
//                }
//            }
            if (manuscript.suffix) {
                switch (titleSize) {
                    case 'default':
                    case 'full':
                        title.push(manuscript.suffix);
                        break;
                    case 'short':
                    case 'norm':
                        break;
                }
            }
        }

        titleString = title.join(', ');

        titleString += ' (';
        if (manuscript.ed_witness) {
            titleString += manuscript.ed_witness;
        } else {
            titleString += ' - ';
        }
        titleString += ')';

        return titleString;
    }

    private normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/get-ms-title.pipe.ts